/**
 * 404 ページ (Phase 3).
 * Figma: #19
 */

import { Link } from '@tanstack/react-router';
import { useEffect } from 'react';

export function NotFoundPage() {
  useEffect(() => {
    document.title = 'ページが見つかりません - PetaCMS';
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f8f7f6]">
      <div className="text-center">
        <p className="text-8xl font-bold text-[#edebe8]">404</p>
        <h1 className="mt-6 text-[24px] font-bold text-[#23221e]">ページが見つかりません</h1>
        <p className="mt-2 text-[14px] text-[#706d65]">
          お探しのページは存在しないか、移動された可能性があります。
        </p>
        <div className="mt-8">
          <Link to="/">
            <button
              type="button"
              className="inline-block rounded-[6px] bg-[#3b82f6] px-8 py-3 text-sm font-medium text-white transition hover:bg-[#1d4ed8]"
            >
              ダッシュボードに戻る
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
